import * as React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../berry/layout/index.jsx';
import ThemeCustomization from 'src/berry/themes';
import { UserDeffer } from 'src/context/user.jsx';
import { JSONProvider, JSONDeffer } from 'src/context/json.jsx';
import { ModalsProvider } from 'src/context/modals.jsx';

import Modals from 'src/controllers/modals.jsx';

const Dashboard = () => {
	const { app_uid } = useParams();
	const has_app_uid = !!app_uid;

	return (
		<ThemeCustomization>
			<UserDeffer>
				<JSONProvider>
					{has_app_uid ? (
						<JSONDeffer>
							<ModalsProvider>
								<Modals />
								<Layout />
							</ModalsProvider>
						</JSONDeffer>
					) : (
						<ModalsProvider>
							<Modals />
							<Layout />
						</ModalsProvider>
					)}
				</JSONProvider>
			</UserDeffer>
		</ThemeCustomization>
	);
};

export default Dashboard;
